export enum DetailStatus {
  Arrived = 'Arribado',
  Delivered = 'Entregado',
  Partial = 'Parcial',
  Pending = 'Pendiente',
  Rejected = 'Rechazado',
  Undelivered = 'No Entregado'
}
